// extracted by mini-css-extract-plugin
module.exports = {"figure":"AvatarImage_figure__lXssp"};